import { useState, useEffect, useCallback } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useFetchDrivers() {
  const { uid } = useFirebaseAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDrivers = useCallback(async () => {
    if (!uid) return;
    setLoading(true);
    try {
      const res = await API.get(`/users/${uid}/driver`);
      console.log('Fetched data:', res.data);

      setData(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [uid]);

  useEffect(() => {
    if (uid) {
      fetchDrivers();
    }
  }, [uid, fetchDrivers]);

  return { data, loading, error, fetchDrivers };
}
